/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ModelDate } from './ModelDate';
import { ModelDateFromJSON, ModelDateFromJSONTyped, ModelDateToJSON } from './ModelDate';

/**
 *
 * @export
 * @interface EventUpdateModel
 */
export interface EventUpdateModel {
    /**
     *
     * @type {string}
     * @memberof EventUpdateModel
     */
    title?: string;
    /**
     *
     * @type {string}
     * @memberof EventUpdateModel
     */
    description?: string;
    /**
     *
     * @type {string}
     * @memberof EventUpdateModel
     */
    link?: string;
    /**
     *
     * @type {ModelDate}
     * @memberof EventUpdateModel
     */
    date?: ModelDate;
}

/**
 * Check if a given object implements the EventUpdateModel interface.
 */
export function instanceOfEventUpdateModel(value: object): boolean {
    return true;
}

export function EventUpdateModelFromJSON(json: any): EventUpdateModel {
    return EventUpdateModelFromJSONTyped(json, false);
}

export function EventUpdateModelFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): EventUpdateModel {
    if (json == null) {
        return json;
    }
    return {
        title: json['title'] == null ? undefined : json['title'],
        description: json['description'] == null ? undefined : json['description'],
        link: json['link'] == null ? undefined : json['link'],
        date: json['date'] == null ? undefined : ModelDateFromJSON(json['date']),
    };
}

export function EventUpdateModelToJSON(value?: EventUpdateModel | null): any {
    if (value == null) {
        return value;
    }
    return {
        title: value['title'],
        description: value['description'],
        link: value['link'],
        date: ModelDateToJSON(value['date']),
    };
}
